import { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate} from 'react-router-dom';
import Login from './pages/Login';
import Shop from './pages/Shop';
import Purchases from './pages/Purchases';
import Favourites from './pages/Favourites';
import Settings from './pages/settings/Settings';
import Locations from './pages/Locations';
import Details from './pages/Details';
import ScrollTop from './components/ScrollTop';
import Orders from './pages/Orders';
import AllLocations from './pages/AllLocations';
import Navbar from './components/Navbar';
import ProductDetails from './components/ProductDetails';
import ProductListings from './pages/ProductListings';
import Post from './pages/Post';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Privacy from './pages/Privacy';
import WorkoutInfo from './pages/WorkoutInfo';
import { HomePath } from './home-path'

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if(location.pathname === '/mobile-shop') {
      navigate('/mobile-shop/login');
    }
  });

  window.addEventListener('load', (event) => {
    localStorage.removeItem('reloadGN');
  });

  return (
      <>
      <ScrollTop />
      {(location?.pathname == HomePath + '/' || location?.pathname == HomePath) ? null : (
        <Navbar />
      )}
      <Routes>
        <Route exact path={HomePath + "/login"} element={<Login />} />
        <Route exact path={HomePath + "/"} element={<Login />} />
        <Route exact path={HomePath + "/home"} element={<Shop />}/>
        <Route exact path={HomePath + "/discover"} element={<Post />}/>
        <Route exact path={HomePath + "/shop"} element={<ProductListings />}/>
        <Route exact path={HomePath + "/orders"} element={<Orders />}/>
        <Route exact path={HomePath + "/cart"} element={<Cart />}/>
        <Route exact path={HomePath + "/checkout"} element={<Checkout />}/>
        <Route exact path={HomePath + "/purchases"} element={<Purchases />}/>
        <Route exact path={HomePath + "/favourites"} element={<Favourites />}/>
        <Route exact path={HomePath + "/product/:id/details"} element={<Details />}/>
        <Route exact path={HomePath + "/product/:id/product-details"} element={<ProductDetails />}/>
        <Route exact path={HomePath + "/locations"} element={<Locations />} />
        <Route exact path={HomePath + "/all-locations"} element={<AllLocations />} />
        <Route exact path={HomePath + "/settings"} element={<Settings />}/>
        <Route exact path={HomePath + "/privacy"} element={<Privacy />}/>
        <Route exact path={HomePath + "/workout-info"} element={<WorkoutInfo />}/>
        {/* <Route exact path={HomePath + "/article"} element={<Post />}/> */}
      </Routes>
      </>
  );
}

export default App;
